<template>
  <div>
    <Head title="Packed Order Details" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/dispatches/picked-orders`">Packed Orders</Link>
      <span class="text-orange-400 font-medium">/</span>{{ order.order_no }}
    </h1>
    <div class="mb-6 w-1/2 float-left">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md float-left" @reset="reset" />
    </div>
    <div class="mb-6 w-1/2 float-right">
      <a
        v-if="(order_details.data.length > 0)"
        class="btn-orange rounded-md px-9 py-3 text-xs cursor-pointer float-right"
        :href="`/packed-orders/${order.id}/skus/download`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
      <a
        type="button" 
        class="rounded-md mr-2 border border-transparent px-3 py-2 float-right bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm sm:leading-5"
        @click="openAddWaybill(order)"
      >
        <span>Add Waybill No</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto w-full">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Ordered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Packed</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Delivered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Returned</th>
          <th class="pb-3 pt-3 px-3">UoM</th>
        </tr>
        <tr v-for="list in order_details.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.sku }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_picked }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_delivered }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_returned }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center  px-3 py-3 focus:text-orange-500">
              {{ list.measure }}
            </span>
          </td>
        </tr>
        <tr v-if="order_details.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="order_details.links" />
  </div>
  <!--modal content-->
  <div v-if="isAddWaybillOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form @submit.prevent="postOrderWayBill">
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <text-input v-model="form.waybill_number" :error="form.errors.waybill_number" class="pb-2 pr-0 w-full lg:w-full" label="Waybill Number" />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="submit" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5" @click="postOrderWayBill">
                Submit
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
      
export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    order: Object,
    order_details: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        waybill_number: null,
        id: this.order.id,
      }),
      search: {
        search: this.filters.search,
      },
      isAddWaybillOpen: false,
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/dispatches/orders/${this.order.id}/details`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    openAddWaybill() {
      this.isAddWaybillOpen = true
    },
    closeModal() {
      this.isAddWaybillOpen = false
    },
    postOrderWayBill() {
      this.form.post('/add-order-waybill-number', {
        onSuccess: () => {
          this.form.reset(
            'waybill_number',
          )
          this.isAddWaybillOpen = false
        }
      })
    },
  },
}
</script>
      